export default __webpack_public_path__ + "static/media/home-interior-design-services-02.ba872035.jpg";